import classnames from 'classnames/bind';
import { FC } from 'react';

import { useTranslation } from '@/i18n';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export const Contents: FC = () => {
  const { t } = useTranslation();
  return (
    <div className={cx('container')}>
      <span className={cx('text')}>
        {t('ai_agents_setting_main_setting_confirm_disable_start_body')}
      </span>
    </div>
  );
};
